<template>
  <div v-if="imageLink !== undefined" class="flex flex-col">
    <div v-for="image in images" :key="image" class="flex-1 w-full">
      <img :src="image" alt="Image" class="w-full h-full" />
    </div>
  </div>
  <div v-else>
    <div class="center">
      <video width="65%" height="65%" controls>
        <source :src="videoLink" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageLink: '',
      images: [],
      videoLink: ''
    }
  },
  mounted() {
    this.imageLink = this.$route.query.imageLink
    this.videoLink = this.$route.query.videoLink

    // imageLink is a comma-joined list of URLs, each encodeURIComponent'd
    // by the caller so a URL containing a comma (or other reserved query
    // characters) can't corrupt the split. Guard decodeURIComponent in case
    // an already-decoded link (e.g. from an older bookmark) is passed in.
    // (imageLink is undefined for the video-link case below, so skip it then.)
    this.images = this.imageLink
      ? this.imageLink.split(',').map((link) => {
          try {
            return decodeURIComponent(link)
          } catch (e) {
            return link
          }
        })
      : []
  }
}
</script>

<style>
.image {
  width: 100%;
  height: 100%;
}

.center {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: burlywood;
}
</style>
